/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import Seo from "../../components/common/Seo";
import Header3 from "../../components/header/header-rslhome";
import Footer3 from "../../components/footer/footer-new";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import BookRideBar from "../../components/hero/hero-rslhome/BookRideBar";
import WhyBookWithUs from "../../components/WhyBookWithUs";
import { useSelector, useDispatch } from "react-redux";
import { getBookARidePage } from "../../redux/slices/common";
import { fetchSeoByPage } from "../../lib/seoHelper";

export default function Rides({ meta }) {
  const dispatch = useDispatch();
  const { bookingRidePageRes } = useSelector(
    (state) => state.common
  );
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(true);


  useEffect(() => {
    setLoader(true);
    dispatch(getBookARidePage());
  }, [dispatch])

  useEffect(() => {
    if (bookingRidePageRes) {
      setLoader(false);
      if (bookingRidePageRes?.status === 1) {
        setData(bookingRidePageRes?.responseData)
      } else {
        setData(null);
      }
    }
  }, [bookingRidePageRes])

  return (
    <div style={{
      backgroundImage: "url('/img/banner/grid.svg')",
    }}>
      <div style={{ height: "150px" }}>
        <Seo meta={meta} />
        <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />
      </div>
      <div style={{ paddingTop: "40px", paddingBottom: "40px" }}>
        <BookRideBar hourly={false} />
      </div>
      <WhyBookWithUs loader={loader} faqs={data?.faqs} features={data?.features} title={data?.title} subtitle={data?.subtitle} />
      {/* Communication Section */}
      <CommunicationChannel data={{
        sectionId: "communicationChannel",
        image: {
          src: "/images/bannerImage/rsl_super_app.svg",
          alt: "RSL SUPER APP"
        }
      }} />

      {/* Footer */}
      <Footer3 bgcolor="#f8f8f8" />
    </div>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}